<template>
  <el-dropdown trigger="click" @command="changeLocale">
    <button type="button" class="admin-language-switcher" :aria-label="current.name">
      <el-icon><Connection /></el-icon>
      <span>{{ current.name }}</span>
      <el-icon><ArrowDown /></el-icon>
    </button>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item
          v-for="item in adminLocales"
          :key="item.code"
          :command="item.code"
          :disabled="item.code === current.code"
        >
          {{ item.name }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ArrowDown, Connection } from '@element-plus/icons-vue'
import { useI18n } from 'vue-i18n'

import {
  adminLocales,
  getAdminLocale,
  writeAdminLocale
} from '@/apps/admin/i18n/locale'

const props = withDefaults(defineProps<{ reloadOnChange?: boolean }>(), {
  reloadOnChange: false
})
const { locale } = useI18n()
const current = computed(() => getAdminLocale(locale.value))

const changeLocale = (value: string): void => {
  const resolved = writeAdminLocale(value)
  if (resolved === locale.value) return

  locale.value = resolved
  document.documentElement.lang = resolved
  if (props.reloadOnChange) window.location.reload()
}
</script>

<style scoped>
.admin-language-switcher {
  display: inline-flex;
  height: 38px;
  padding: 0 8px;
  align-items: center;
  gap: 6px;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font: inherit;
}

.admin-language-switcher:hover { opacity: 0.88; }
.admin-language-switcher .el-icon:last-child { font-size: 12px; }
</style>
